import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const BannerManagementStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  /* .main-content {
    min-width: 1600px;
  } */

  .table-wrapper {
    margin-top: 21px;
  }

  .table {
    .table-row {
      .company-name {
        min-width: 300px;
        flex: 1 1 auto;
      }

      .status {
        width: 7%;
        min-width: 95px;
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
